import script from "./UserCompanyRelationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCompanyRelationPage.vue?vue&type=script&setup=true&lang=js"

import "./UserCompanyRelationPage.vue?vue&type=style&index=0&id=1f37b3ec&scoped=true&lang=scss"
/* custom blocks */
import block0 from "./UserCompanyRelationPage.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f37b3ec"]])

export default __exports__